var path = '/pages/contacts/directives/sections/checkins/show-checkin-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n  <h2>Check-In</h2>\n</div>\n<div class=\"modal-body\">\n  <checkin model=\"vm.checkin\"></checkin>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/directives/sections/checkins/show-checkin-modal.tpl.html
// module id = 2218
// module chunks = 1